/**
 * Toast position
 */
export class NotificationPosition {
  static leftTop = 'leftTop';
  static leftCenter = 'leftCenter';
  static leftBottom = 'leftBottom';

  static rightTop = 'rightTop';
  static rightCenter = 'rightCenter';
  static rightBottom = 'rightBottom';

  static centerTop = 'centerTop';
  static centerCenter = 'centerCenter';
  static centerBottom = 'centerBottom';
}
